module.exports = "<uch></uch>\r\n<head-title params='title:\"ID管家\"'></head-title>\r\n<id-shield></id-shield>";


//////////////////
// WEBPACK FOOTER
// ./src/component/idShield/idShield.html
// module id = 192
// module chunks = 0